// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --border-radius-none: 0px;
  --border-radius-2xs: 4px;
  --border-radius-xs: 8px;
  --border-radius-sm: 12px;
  --border-radius-md: 16px;
  --border-radius-lg: 24px;
  --border-radius-xl: 32px;
  --border-radius-2xl: 40px;
  --border-radius-circular: 500px;
  --border-width-none: 0px;
  --border-width-xs: 1px;
  --border-width-sm: 1.5px;
  --border-width-md: 2px;
  --border-width-lg: 3px;
  --border-width-xl: 4px;
  --opacity-super-low: .15;
  --opacity-low: .35;
  --opacity-high: .50;
  --opacity-super-high: .80;
  --shadow-none: 0 0 0 0 0;
  --shadow-level-1: 0px 4px 16px -2px rgb(55 50 46 / .15);
  --shadow-level-2: 0px 12px 24px -6px rgb(55 50 46 / .15);
  --shadow-level-3: 0px 16px 32px 0px rgb(55 50 46 / .15);
  --spacing-none: 0px;
  --spacing-half: 4px;
  --spacing-1x: 8px;
  --spacing-1_5x: 12px;
  --spacing-2x: 16px;
  --spacing-2_5x: 20px;
  --spacing-3x: 24px;
  --spacing-4x: 32px;
  --spacing-5x: 40px;
  --spacing-6x: 48px;
  --spacing-7x: 56px;
  --spacing-8x: 64px;
  --spacing-9x: 72px;
  --spacing-10x: 80px;
  --spacing-15x: 120px;
  --spacing-20x: 160px;
  --spacing-25x: 200px;
  --size-half: 4px;
  --size-1x: 8px;
  --size-2x: 16px;
  --size-2_5x: 20px;
  --size-3x: 24px;
  --size-4x: 32px;
  --size-5x: 40px;
  --size-6x: 48px;
  --size-7x: 56px;
  --size-8x: 64px;
  --size-9x: 72px;
  --size-10x: 80px;
  --size-11x: 88px;
  --size-12x: 96px;
  --size-13x: 104px;
  --size-14x: 112px;
  --size-15x: 120px;
  --size-20x: 160px;
  --size-25x: 200px;
  --size-30x: 240px;
  --size-35x: 280px;
  --size-40x: 320px;
  --bg-blur-light: 4px;
  --bg-blur-strong: 8px;
}
`, "",{"version":3,"sources":["webpack://./node_modules/@gol-smiles/tangerina-tokens/dist/web/globals/shape.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,yBAAyB;EACzB,+BAA+B;EAC/B,wBAAwB;EACxB,sBAAsB;EACtB,wBAAwB;EACxB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,wBAAwB;EACxB,uDAAuD;EACvD,wDAAwD;EACxD,uDAAuD;EACvD,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;AACvB","sourcesContent":[":root {\n  --border-radius-none: 0px;\n  --border-radius-2xs: 4px;\n  --border-radius-xs: 8px;\n  --border-radius-sm: 12px;\n  --border-radius-md: 16px;\n  --border-radius-lg: 24px;\n  --border-radius-xl: 32px;\n  --border-radius-2xl: 40px;\n  --border-radius-circular: 500px;\n  --border-width-none: 0px;\n  --border-width-xs: 1px;\n  --border-width-sm: 1.5px;\n  --border-width-md: 2px;\n  --border-width-lg: 3px;\n  --border-width-xl: 4px;\n  --opacity-super-low: .15;\n  --opacity-low: .35;\n  --opacity-high: .50;\n  --opacity-super-high: .80;\n  --shadow-none: 0 0 0 0 0;\n  --shadow-level-1: 0px 4px 16px -2px rgb(55 50 46 / .15);\n  --shadow-level-2: 0px 12px 24px -6px rgb(55 50 46 / .15);\n  --shadow-level-3: 0px 16px 32px 0px rgb(55 50 46 / .15);\n  --spacing-none: 0px;\n  --spacing-half: 4px;\n  --spacing-1x: 8px;\n  --spacing-1_5x: 12px;\n  --spacing-2x: 16px;\n  --spacing-2_5x: 20px;\n  --spacing-3x: 24px;\n  --spacing-4x: 32px;\n  --spacing-5x: 40px;\n  --spacing-6x: 48px;\n  --spacing-7x: 56px;\n  --spacing-8x: 64px;\n  --spacing-9x: 72px;\n  --spacing-10x: 80px;\n  --spacing-15x: 120px;\n  --spacing-20x: 160px;\n  --spacing-25x: 200px;\n  --size-half: 4px;\n  --size-1x: 8px;\n  --size-2x: 16px;\n  --size-2_5x: 20px;\n  --size-3x: 24px;\n  --size-4x: 32px;\n  --size-5x: 40px;\n  --size-6x: 48px;\n  --size-7x: 56px;\n  --size-8x: 64px;\n  --size-9x: 72px;\n  --size-10x: 80px;\n  --size-11x: 88px;\n  --size-12x: 96px;\n  --size-13x: 104px;\n  --size-14x: 112px;\n  --size-15x: 120px;\n  --size-20x: 160px;\n  --size-25x: 200px;\n  --size-30x: 240px;\n  --size-35x: 280px;\n  --size-40x: 320px;\n  --bg-blur-light: 4px;\n  --bg-blur-strong: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
